// extracted by mini-css-extract-plugin
export default {"action":"_3l87ZXEN8gUv_mlXr1NAVN","header":"_3gcmL4dB5KQqpIrYO3oss0","content":"_m2TLjgTXTDbgOa-3M0jx"};